import Cookies from "js-cookie";

const HANDOFF_COOKIE = 'cruzcontrolHandoff';

const cookieDomain = () =>
  import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? undefined : '.cruzcontrol.app';

/**
 * The idle-timeout clock (sessionTimestamp) lives in this subdomain's localStorage,
 * so it survives tab closes and the portal cannot reach it. A user who was last here
 * more than an hour ago would otherwise be logged straight back out on arrival, even
 * with a session the portal authenticated seconds earlier.
 *
 * The portal stamps a short-lived cookie on the shared domain when it authenticates a
 * user and when it hands off to a tenant. Take whichever of the two is more recent, then
 * delete the cookie so a single handoff cannot extend the idle window more than once.
 *
 * Must run before the router guard and App.vue's session checks read sessionTimestamp.
 * Safe to call more than once; the cookie is gone after the first call that sees it.
 */
export function applyPortalHandoff(store) {
  const stamp = Cookies.get(HANDOFF_COOKIE);
  if (!stamp) return;

  Cookies.remove(HANDOFF_COOKIE, { domain: cookieDomain(), path: '/' });

  const handoff = new Date(stamp);
  if (isNaN(handoff.getTime())) return;

  const local = store.state.sessionTimestamp;
  if (local == null || handoff > new Date(local)) {
    store.commit("setSessionTimestamp", handoff);
  }
}
